export {
  checkSkillCompatibility,
  getBannerJobList,
  getCompanyJobList,
  getJobDetail,
  getRelatedJobs,
  getSavedJobs,
  getSkillCompatibility,
  getSuggestedJobList,
  getTopCountWorks,
  increaseShareCount,
  saveJob,
  fetchHomeSearch,
  searchJobs,
  sendCV,
  setBannerJobClickCount,
} from '@/features/jobs/api/jobs.api';

export { jobQueryKeys } from '@/features/jobs/api/jobs.keys';

export {
  useBannerJobClickCount,
  useBannerJobList,
  useGetCompanyJobList,
  useGetJobDetail,
  useGetRelatedJobs,
  useGetSavedJobs,
  useGetTopCountWorks,
  useCheckSkillCompatibility,
  useGetSkillCompatibility,
  useJobAutocomplete,
  useHomeSearch,
  useSaveJob,
  useSavedJobIds,
  useSearchJobs,
  useSendCv,
  useShareJob,
  useSuggestedJobList,
} from '@/features/jobs/api/jobs.queries';
